import { Text, View, Link } from "@react-pdf/renderer";
import { styles } from "./reportStyles";

const referenceText = { ...styles.textSpacedJustified, lineHeight: 1.5, marginBottom: 10 } as const;
const linkStyle = { color: "#1a0dab" } as const;

export const EegDocumentAppendixView = () => {
    return (
        <View>
            <Text style={[styles.sectionTitle, styles.centeredText, {marginBottom: 16}]}>ANEXO</Text>

            <Text style={styles.textSpacedJustified}>
                O Eletroencefalograma Quantitativo (qEEG), também conhecido como mapeamento cerebral, é uma ferramenta de avaliação neurofisiológica não invasiva que mede e analisa a atividade elétrica do cérebro.
            </Text>

            <Text style={styles.textSpacedJustified}>
                Através de um eletroencefalograma (EEG) padrão, onde 19 eletrodos ativos são colocados no couro cabeludo para registar as ondas cerebrais, os dados brutos são obtidos, preparados e analisados, quantificando os vários padrões de ondas cerebrais e a sua distribuição no cérebro. Os resultados são então comparados a uma base de dados normativa de atividade cerebral de indivíduos saudáveis da mesma idade e sexo. Esta comparação ajuda a identificar áreas e padrões de atividade cerebral que são estatisticamente diferentes do esperado, ou seja, manifestam desregulação.
            </Text>

            <Text style={styles.textSpacedJustified}>
                Na prática clínica, o qEEG é usado como uma ferramenta de avaliação objetiva para auxiliar no diagnóstico e no planeamento do tratamento de várias condições neurológicas e psiquiátricas, incluindo PHDA (TDAH), ansiedade, depressão e lesão cerebral traumática.
            </Text>

            <Text style={styles.textSpacedJustified}>
                As ondas cerebrais são uma representação do funcionamento elétrico cerebral e a presença de desregulações nesse funcionamento está associada à presença de determinada sintomatologia no indivíduo.
            </Text>

            <Text style={[styles.textBold, { marginTop: 10, lineHeight: 1.5 }]}>
                Explicação completa sobre como interpretar o relatório de qEEG e os mapas cerebrais:
            </Text>
            <Link src="https://media.neuroimprove.pt/como-compreender-o-mapa-cerebral">
                <Text style={[styles.text, linkStyle, { lineHeight: 1.5 }]}>
                    Como compreender o Mapa Cerebral?
                </Text>
            </Link>

            <Text style={[styles.textBold, { marginTop: 10, lineHeight: 1.5 }]}>Referências:</Text>

            <Text style={referenceText}>
                Santana, C., Bião, M. (2018). Eficácia do Neurofeedback no tratamento da ansiedade patológica e transtornos ansiosos: revisão sistemática da literatura. Psicologia, Saúde & Doenças, 19(2), 234–242.{" "}
                <Link src="https://www.researchgate.net/publication/327796864_NEUROFEEDBACK_EFFICACY_IN_THE_ANXIETY_DISORDER_AND_PATHOLOGICAL_ANXIETY_TREATMENT_SYSTEMATIC_LITERATURE_REVIEW"><Text style={linkStyle}>DOI:10.15309/18psd190206</Text></Link>
            </Text>
            <Text style={referenceText}>
                Thatcher, R. W., Walker, R. A., Biver, C. J., North, D. N., & Curtin, R. (2003). Quantitative EEG Normative Databases: Validation and Clinical Correlation. Journal of Neurotherapy, 7(3–4), 87–121.{" "}
                <Link src="https://doi.org/10.1300/J184v07n03_05"><Text style={linkStyle}>DOI:10.1300/J184v07n03_05</Text></Link>
            </Text>
            <Text style={referenceText}>
                Thatcher, R. W. (1998). Normative EEG databases and EEG biofeedback. Journal of Neurotherapy, 2(4), 8–39.{" "}
                <Link src="https://doi.org/10.1300/J184v02n04_02"><Text style={linkStyle}>DOI:10.1300/J184v02n04_02</Text></Link>
            </Text>
            <Text style={referenceText}>
                Zhong, X., Yuan, X., Dai, Y., Zhang, X., & Jiang, C. (2025). Neurofeedback training for executive function in ADHD children: a systematic review and meta-analysis. Scientific reports, 15(1), 28148.{" "}
                <Link src="https://doi.org/10.1038/s41598-025-94242-4"><Text style={linkStyle}>DOI:10.1038/s41598-025-94242-4</Text></Link>
            </Text>
        </View>
    );
};
